export const labels = {
    nl_NL: {
        home: 'Home',
        mainMenu: 'Hoofdnavigatie openen',
        back: 'Terug naar de homepage',
        subMenu: 'Open sub menu'
    },
    nl_BE: {
        home: 'Home',
        mainMenu: 'Hoofdnavigatie openen',
        back: 'Terug naar de homepage',
        subMenu: 'Open sub menu'
    },
    en_GB: {
        home: 'Home',
        mainMenu: 'Open navigation',
        back: 'Back to homepage',
        subMenu: 'Open sub menu'
    },
    fr_BE: {
        home: 'Home',
        mainMenu: 'Ouvrir la navigation principale',
        back: 'Retour à l\'accueil',
        subMenu: 'Ouvrir la navigation'
    }
}
